import { registerFavoriteOperations } from './features/favoriteOperations';
import { registerCartOperations } from './features/cartOperations';
import { registerUserPreferencesOperations } from './features/userPreferencesOperations';
import { registerCompareOperations } from './features/compareOperations';

let initialized = false;

export function initOfflineOperations(): void {
  if (initialized) return;
  initialized = true;
  registerFavoriteOperations();
  registerCartOperations();
  registerUserPreferencesOperations();
  registerCompareOperations();
}
